const MONITOR_DT_SELECTORS =
  '#dt_quotum, #dt_private_fixe_income, #dt_public_fixed_income, #dt_margin, #dt_transfers, ' +
  '#dt_purchase_commitment, #dt_currency_term, #dt_loan, #dt_swap_cetip, #dt_variable_income, ' +
  '#dt_payment_request, #dt_exchange, #dt_future, #dt_passive_pco, #dt_passive_quota, #dt_proposals, ' +
  '#dt_dation_payment';

function sheetName() {
  var tipoBoleta = $("#q_ticket_kind_eq");
  if (tipoBoleta.length > 0) {
    return tipoBoleta[0][tipoBoleta[0].selectedIndex].text == "Todas" ? "Relatório de boletas" : tipoBoleta[0][tipoBoleta[0].selectedIndex].text;
  }
  return "Relatório de propostas";
}

const SUMMABLE_EXPORT_HEADER_PATTERN =
  /valor|quantidade|total|preço|preco|cota|financeiro|diferença|diferenca|compra|venda|unitário|unitario|depósito|deposito|retirada|nominal|no\.?\s*(boleta|proposta)|n[uú]mero\s+da\s+(boleta|proposta)/i;

const TEXT_ONLY_EXPORT_HEADER_PATTERN =
  /c[oó]digo(?!\s*aditamento)|cetip|cnpj|cpf|\bconta\b|documento|ag[eê]ncia/i;

function isSummableExportHeader(header) {
  return SUMMABLE_EXPORT_HEADER_PATTERN.test(header);
}

function isTextOnlyExportHeader(header) {
  return TEXT_ONLY_EXPORT_HEADER_PATTERN.test(header);
}

function isCetipAccountExportHeader(header) {
  return /conta\s+cetip/i.test(header);
}

function isNumericOnlyValue(value) {
  if (!value) return false;

  return /^\d+$/.test(String(value).replace(/\s/g, ''));
}

function columnMarkedExportAsText(node, columnIndex, $table) {
  const $node = $(node);
  const $th = $table.find('thead tr:first th').eq(columnIndex);

  return $th.hasClass('export-as-text') || $node.hasClass('export-as-text');
}

function looksLikeScientificNotation(value) {
  if (!value) return false;

  const str = String(value).trim();
  // Excel interpreta "E" entre dígitos como expoente (ex.: 26E04915804 → #NULO! / notação científica)
  return /\d[eE]\d/.test(str) || /^\d+[eE][+-]?\d+$/.test(str);
}

function parseExportNumericValue(value) {
  if (!value || value === '-') return null;

  let normalized = value.replace(/\s/g, '').replace(/^R\$?/i, '');
  if (normalized.includes(',')) {
    normalized = normalized.replace(/\./g, '').replace(',', '.');
  }

  const num = parseFloat(normalized);
  return Number.isFinite(num) ? num : null;
}

let monitorExcelTextCells = [];

function excelColumnLetter(columnIndex) {
  let letter = '';
  let col = columnIndex + 1;

  while (col > 0) {
    const mod = (col - 1) % 26;
    letter = String.fromCharCode(65 + mod) + letter;
    col = Math.floor((col - 1) / 26);
  }

  return letter;
}

function escapeXmlText(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

function shouldExportCellAsText(node, column, header, value) {
  const $table = $(node).closest('table');

  return columnMarkedExportAsText(node, column, $table) || shouldExportAsText(header, value);
}

function exportColumnIndexForTableColumn($table, tableColumnIndex) {
  const dt = monitorDataTableApi($table[0]);
  let exportIndex = 0;

  $table.find('thead tr:first th').each(function (i) {
    if (i >= tableColumnIndex) return false;

    const $th = $(this);
    if ($th.hasClass('noExport')) return;
    if (dt && typeof dt.column === 'function' && !dt.column(i).visible()) return;

    exportIndex++;
  });

  return exportIndex;
}

const MONITOR_EXCEL_DATA_ROW_OFFSET = 3; // linha do título + cabeçalho + base 1

function setExcelCellInlineText(sheet, excelRowNumber, columnIndex, value) {
  const cellRef = `${excelColumnLetter(columnIndex)}${excelRowNumber}`;
  const $sheet = $(sheet);
  let $cell = $sheet.find(`c[r="${cellRef}"]`);

  if (!$cell.length) {
    const $targetRow = $sheet.find('sheetData row').filter(function () {
      return parseInt($(this).attr('r'), 10) === excelRowNumber;
    }).first();

    if (!$targetRow.length) return;

    $targetRow.append(
      `<c r="${cellRef}" t="inlineStr"><is><t xml:space="preserve">${escapeXmlText(value)}</t></is></c>`
    );
    return;
  }

  $cell.attr('t', 'inlineStr');
  $cell.removeAttr('s');
  $cell.empty();
  $cell.append(`<is><t xml:space="preserve">${escapeXmlText(value)}</t></is>`);
}

function customizeMonitorExcelExport(xlsx) {
  const cells = monitorExcelTextCells;
  monitorExcelTextCells = [];

  if (!cells.length) return;

  const sheet = xlsx.xl.worksheets['sheet1.xml'];

  cells.forEach(({ row, column, value }) => {
    setExcelCellInlineText(sheet, row + MONITOR_EXCEL_DATA_ROW_OFFSET, column, value);
  });
}

function excelExportCellValue(data, row, column, node) {
  const clean = $('<div>').html(data).text().trim();
  const $table = $(node).closest('table');
  const tableColumnIndex = node.cellIndex;
  const header = $table.find('thead tr:first th').eq(tableColumnIndex).text().trim();

  if (shouldExportCellAsText(node, tableColumnIndex, header, clean)) {
    monitorExcelTextCells.push({
      row,
      column: exportColumnIndexForTableColumn($table, tableColumnIndex),
      value: clean,
    });
    return clean;
  }

  if (isCetipAccountExportHeader(header) && isNumericOnlyValue(clean)) {
    const numericValue = parseExportNumericValue(clean);
    if (numericValue !== null) return numericValue;
  }

  if (isSummableExportHeader(header)) {
    const numericValue = parseExportNumericValue(clean);
    if (numericValue !== null) return numericValue;
  }

  return clean;
}

function shouldExportAsText(header, value) {
  if (isCetipAccountExportHeader(header) && isNumericOnlyValue(value)) {
    return false;
  }

  if (isTextOnlyExportHeader(header)) {
    return true;
  }

  if (/^\d{10,}$/.test(value) || looksLikeScientificNotation(value)) {
    return true;
  }

  return false;
}

function monitorColvisColumnText(dt, idx, title) {
  const header = dt.column(idx).header();
  if (!header) return title;

  const $header = $(header);
  if ($header.hasClass('noVis') || $header.hasClass('noExport')) {
    return title;
  }

  if ($header.hasClass('export-as-text') || isTextOnlyExportHeader(title)) {
    if (isCetipAccountExportHeader(title)) {
      return title;
    }

    return `${title} (contagem)`;
  }

  if (isSummableExportHeader(title)) {
    return `${title} (soma)`;
  }

  return title;
}

function monitorDataTableApi(el) {
  if (typeof window.DataTable === 'undefined') return null;

  if (window.DataTable.isDataTable && window.DataTable.isDataTable(el)) {
    if (typeof window.DataTable.get === 'function') {
      return window.DataTable.get(el);
    }
    if (typeof window.DataTable.Api === 'function') {
      return new window.DataTable.Api(el);
    }
  }

  if ($.fn.dataTable && $.fn.dataTable.isDataTable(el)) {
    return $(el).DataTable();
  }

  return null;
}

function destroyExistingMonitorDataTables($tables) {
  $tables.each(function () {
    const api = monitorDataTableApi(this);
    if (api && typeof api.destroy === 'function') {
      api.destroy();
    }
  });
}

// Turbolinks restaura HTML com toolbar/busca do DataTables; limpa antes de reinicializar.
function cleanupOrphanedMonitorDataTableChrome($tables) {
  $tables.each(function () {
    const $table = $(this);
    let $scope = $table.closest('.table-responsive, .resizable-table-container, .card-body').first();
    if (!$scope.length) $scope = $table.parent();

    $scope.find('.dt-toolbar').remove();

    $scope.find('.dt-container, .dataTables_wrapper').each(function () {
      const $wrapper = $(this);
      if (!$wrapper.find('table').filter($table).length) return;
      if (monitorDataTableApi($table[0])) return;

      $table.detach().insertBefore($wrapper);
      $wrapper.remove();
    });
  });
}

function initMonitorDataTables() {
  const tables = $(MONITOR_DT_SELECTORS);
  if (!tables.length) return;

  destroyExistingMonitorDataTables(tables);
  cleanupOrphanedMonitorDataTableChrome(tables);

  new DataTable(tables, {
    bStateSave: true,
    bRestore: true,
    info: false,
    searching: true,
    paging: false,
    dom: '<"dt-toolbar"Bf>t',
    columnDefs: [
      { orderable: false, targets: [0] }
    ],
    buttons: [
      {
        extend: 'colvis',
        text: 'Escolher Colunas',
        columns: ':not(.noVis)',
        columnText: monitorColvisColumnText,
      },
      {
        extend: 'columnVisibility',
        text: 'Restaurar Colunas',
        visibility: true,
      },
      {
        extend: 'excelHtml5',
        sheetName: sheetName(),
        title: sheetName(),
        text: '<i class="fas fa-file-excel"></i>',
        className: 'dt-button',
        customize: customizeMonitorExcelExport,
        exportOptions: {
          columns: ':visible:not(.noExport)',
          format: {
            body: function (data, row, column, node) {
              return excelExportCellValue(data, row, column, node);
            }
          }
        },
        attr: {
          style: 'background-color:rgb(76, 175, 86); color: white; border-radius: 5px;',
        },
      },
    ],
    language: {
      search: '',
      searchPlaceholder: 'Digite para buscar...',
    },
  });
}

onLoad(() => {
  initMonitorDataTables();
});

document.addEventListener('turbolinks:before-cache', () => {
  if (typeof $ === 'undefined') return;

  const tables = $(MONITOR_DT_SELECTORS);
  if (!tables.length) return;

  destroyExistingMonitorDataTables(tables);
  cleanupOrphanedMonitorDataTableChrome(tables);
});
